/**
 * Cliente público del Academy Service: knowledge pages (wiki / manuales).
 * En producción, definir REACT_APP_ACADEMY_API_URL en .env.production (ej. https://api.academy.tnonetwork.com).
 * Origen sin barra final; se concatena con /api/academy/knowledge-pages/...
 */
const rawBase =
  (process.env.REACT_APP_ACADEMY_API_URL || '').trim().replace(/\/$/, '') ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.academy.tnonetwork.com'
    : 'http://localhost:8000');

const API_PREFIX = '/api/academy/knowledge-pages';

function buildUrl(path) {
  return `${rawBase}${API_PREFIX}${path}`;
}

/**
 * @param {string} category
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function fetchKnowledgePagesByCategory(category) {
  const encoded = encodeURIComponent(category);
  const res = await fetch(buildUrl(`/category/${encoded}`), {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'omit',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Academy knowledge-pages: ${res.status} ${text || res.statusText}`);
  }
  return res.json();
}
